import { FloatingTableMenuController } from '../../shared/table';

export class AccountMenuController extends FloatingTableMenuController<null> {
  private static readonly MENU_KEY = 'account';

  toggle(event: MouseEvent): void {
    if (this.openMenuId() === AccountMenuController.MENU_KEY) {
      this.close();
      return;
    }
    this.openMenuId.set(AccountMenuController.MENU_KEY);
    this.openMenuItem.set(null);
  }

  close(): void {
    this.openMenuId.set(null);
    this.openMenuItem.set(null);
    this.menuPosition.set(null);
  }

  isOpen(): boolean {
    return this.openMenuId() === AccountMenuController.MENU_KEY;
  }

  isOutsideClick(event: MouseEvent): boolean {
    return !this.isFloatingMenuEventTarget(event.target, ['.shell__account', '.shell__account-menu']);
  }
}
